<ng-container [formGroup]="form">
    <div [formGroupName]="question.groupName" class="flex items-start flex-wrap mb-4 w-full" [ngClass]="question.styles">
        @for (questionPart of question.questions; track questionPart; let isLast = $last; let isFirst = $first; let index = $index) {
            @if (questionPart.controlType === CONTROL_TYPES.Textbox) {
                <vp-textbox [form]="formGroup" [question]="questionPart" [ngClass]="'text-control-' + index"> </vp-textbox>
            }
            <!-- <div class="ca-subscript relative">
                  <div class="absolute ca-error-message">
                    <ca-form-error-message>
                      {{ errorMessage | translate }}
                    </ca-form-error-message>
                  </div>
                </div> -->
        }
        <button
            type="button"
            mat-stroked-button
            data-testid="apply-advanced-search-filter"
            class="ca-button ca-button-s ms-3 mt-2"
            (click)="search()"
        >
            <span> {{ 'COMMON.BUTTONS.APPLY' | translate }} </span>
        </button>
    </div>
    @if (resultQuestion?.options?.length) {
        <h5 class="mb-4">{{ resultQuestion!.question | translate }}</h5>
        <vp-radio [form]="formGroup" [question]="resultQuestion!"></vp-radio>
    } @else if (!resultQuestion?.options?.length && formGroup.touched && !loading) {
        <h5 class="mb-4">{{ question!.noResultsTitle | translate }}</h5>
        <span class="ca-text-md vp-text-grey">{{ question!.noResultsDescription | translate }}</span>
    }
</ng-container>
